import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

const IconPdfDocument = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
      >
        <g clipPath="url(#clip0_1780_96706)">
          <path fill="#fff" fillOpacity="0.01" d="M0 0H16V16H0z"></path>
          <path
            fill={color}
            fillRule="evenodd"
            d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm1.23 8.113h.323c.744 0 .802-.214.802-.517 0-.345-.179-.514-.545-.514h-.58v1.031zM7.425 9.57h.443c.494 0 1-.147 1-1.237 0-1.1-.534-1.24-1-1.24h-.444v2.477h.001zm-4.45 1.091h-.72A.256.256 0 012 10.404V6.255c0-.14.114-.255.255-.255h1.663c.989 0 1.68.656 1.68 1.596 0 .953-.677 1.593-1.683 1.593H3.23v1.215a.256.256 0 01-.256.256zm4.967 0H6.448a.255.255 0 01-.256-.256V6.255c0-.14.115-.255.255-.255h1.495c1.405 0 2.179.825 2.179 2.323 0 1.506-.774 2.337-2.179 2.337zm3.851 0h-.72a.256.256 0 01-.256-.256V6.255c0-.14.115-.255.255-.255h2.673c.14 0 .255.115.255.255v.587a.255.255 0 01-.255.255h-1.697v.76h1.528c.142 0 .256.115.256.256v.578c0 .14-.114.255-.256.255h-1.528v1.458a.256.256 0 01-.255.256z"
            clipRule="evenodd"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_1780_96706">
            <path fill="#fff" d="M0 0H16V16H0z"></path>
          </clipPath>
        </defs>
      </svg>
    </SvgWrapper>
  );
};

export default IconPdfDocument;
